import type { PartSceneBundle } from './components/PartViewer3D'

/**
 * UID-311 — a small, hand-picked set of demo parts (from
 * `buildDemoLibrary`'s stable base set) get a real, interactive 3D preview
 * using fictiv-3d-viewer's own canned test-part geometry (generic "cube with
 * a hole/pocket" shapes — NOT real geometry for these specific parts). Every
 * other part, including all 57 real motorcycle-subframe BOM parts, keeps
 * `ConfigViewerPlaceholder`'s honest thumbnail/icon fallback.
 *
 * Keyed on `sourceable.name` rather than `sourceable.id` — the id embeds a
 * per-account UUID and isn't stable across a re-seeded demo account, while
 * the name is hardcoded literal text in every fixture.
 */
export const DEMO_SCENE_BY_PART_NAME: Readonly<Record<string, PartSceneBundle>> = {
  'CNC bracket': {
    mesh_files: {
      part_geometry: { file: '/assets/demo-3d-scenes/cnc-bracket/part_geometry.json' },
    },
  },
  'Sensor mount': {
    mesh_files: {
      part_geometry: { file: '/assets/demo-3d-scenes/sensor-mount/part_geometry.json' },
    },
  },
}
